<template>
  <div class="ss__customer__service">
    <template v-if="onlyHelp">
      <SsButton2
        :href="help.link"
        target="_blank"
        class="ss__customer__service__button ss__customer__service__button--onlyHelp"
        @click="openWeixinServiceLink"
        type="text">
        <i :class="help.icon" key="help"/>
        <span>{{ help.label }}</span>
      </SsButton2>
    </template>
    <div v-else ref="mainPropover">
      <SsButton2
        class="ss__customer__service__button"
        type="text"
        @click="togglePopover">
        <Transition name="btn__fade">
          <i v-if="!popoverVisible" class="ssCommunityIcon__questionMark" key="help"/>
          <i v-else class="ssCommunityIcon__cancel" key="cancel"/>
        </Transition>
      </SsButton2>
      <SsFeaturePopover
        class="comp__SsFeaturePopover"
        :visible.sync="popoverVisible"
        :show-star="false"
        :show-close="false"
        :targetEl="$el"
        transition-name="ss__customer__service__popover">
        <ul class="ss__customer__service__list">
          <li v-if="help">
            <SsButton2
              :href="help.link"
              target="_blank"
              class="ss__customer__service__item__link"
              @click="openWeixinServiceLink"
              type="text">
              <i :class="help.icon"/>
              <span>{{ help.label }}</span>
            </SsButton2>
          </li>
          <li v-if="mail">
            <a
              :href="mail.link"
              target="_blank"
              class="ss__customer__service__item__link">
              <i :class="mail.icon"/>
              <span>{{ mail.label }}</span>
            </a>
          </li>
          <li v-if="bussiness">
            <a
              :href="bussiness.link"
              target="_blank"
              class="ss__customer__service__item__link">
              <i :class="bussiness.icon"/>
              <span>{{ bussiness.label }}</span>
            </a>
          </li>
          <li v-if="app">
            <a
              :href="app.link"
              target="_blank"
              class="ss__customer__service__item__link">
              <i :class="app.icon"/>
              <span>{{ app.label }}</span>
            </a>
          </li>
        </ul>
      </SsFeaturePopover>
    </div>
    <transition name="mask">
      <div
        v-show="popoverVisible || weixinServiceVisible"
        class="ss__customer__service__mask"
        @click="onModalClick">
      </div>
    </transition>
    <SsFeaturePopover
      class="comp__SsFeaturePopover comp__SsFeaturePopover__help"
      :visible.sync="weixinServiceVisible"
      :show-star="false"
      :show-close="false"
      :targetEl="$el"
      transition-name="ss__customer__service__popover">
      <div class="ss__customer__service__qrcode__wrapper">
        <div class="ss__customer__service__qrcode__label">请用微信手机端扫码咨询客服</div>
        <img :src="help.qrcode" width="200" height="200">
      </div>
    </SsFeaturePopover>
  </div>
</template>

<script>
import SsButton2 from '../SsButton2'
import SsFeaturePopover from '../SsFeaturePopover'
export default {
  name: 'SsCustomerService',

  components: {
    SsButton2,
    SsFeaturePopover
  },

  props: {
    onlyHelp: {
      type: Boolean,
      default: false
    },
    help: {
      type: Object,
      default: () => ({
        icon: 'ssCommunityIcon__help',
        label: '联系客服',
        link: 'https://work.weixin.qq.com/kfid/kfc53f2e1734a1f6d1a',
        qrcode: 'https://cdn-static.sspai.com/ui/qrcode_service.png'
      })
    },
    mail: {
      type: Object,
      default: () => ({
        icon: 'ssCommunityIcon__mail',
        label: '发送邮件',
        link: 'mailto:contact@sspai.com'
      })
    },
    bussiness: {
      type: Object,
      default: () => ({
        icon: 'ssCommunityIcon__idea',
        label: '商务合作',
        link: 'https://sspai.com/page/bussiness'
      })
    },
    app: {
      type: Object,
      default: () => ({
        icon: 'ssCommunityIcon__download',
        label: '少数派 App',
        link: 'https://sspai.com/page/client'
      })
    },
    openWeixinServiceInNewTab: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      popoverVisible: false,
      weixinServiceVisible: false,
      timer: null
    }
  },

  methods: {
    showPopover () {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.popoverVisible = true
    },
    hidePopover () {
      this.timer = setTimeout(() => {
        this.popoverVisible = false
      }, 150)
    },
    togglePopover () {
      this.popoverVisible = !this.popoverVisible
    },
    onModalClick () {
      this.popoverVisible = false
      this.weixinServiceVisible = false
    },
    openWeixinServiceLink () {
      if (this.openWeixinServiceInNewTab) {
        this.$openLink(this.help.link, '_blank')
      } else {
        this.weixinServiceVisible = true
      }
    }
  },

  mounted () {
    if (!('ontouchstart' in window) && !this.onlyHelp) {
      this.$refs.mainPropover.addEventListener('mouseenter', this.showPopover)
      this.$refs.mainPropover.addEventListener('mouseleave', this.hidePopover)
    }
  }
}
</script>

<style lang="stylus" scoped>
.ss__customer__service {
  display: inline-block;
  color: var(--B8-t);
}
.ss__customer__service__button {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width: var(--width-SsCustomerServiceBtn, 40px);
  height: var(--height-SsCustomerServiceBtn, 40px);
  border-radius: var(--radius-SsCustomerServiceBtn, 40px);
  border: var(--border-SsCustomerServiceBtn, (1px solid var(--B3-t)));
  background: var(--bg-SsCustomerServiceBtn, var(--B0-t-overlay));
  box-shadow: var(--shadow-SsCustomerServiceBtn, var(--shadow-level-2));
  font-size: var(--size-SsCustomerServiceBtnText, 15px);
  color: var(--color-SsCustomerServiceBtn, var(--B6-t));
  position: relative;
  z-index: 2;
  transition: color var(--a-dur-short) var(--a-func-short);
  i {
    pointer-events: none;
    position: absolute;
    font-size: var(--size-SsCustomerServiceBtnIcon, 20px);
  }
  &:hover {
    color: var(--color-SsCustomerServiceBtn--hover, var(--B8-t));
  }
}
.ss__customer__service__mask {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: var(--B8-t);
  opacity: 0;
}
.btn__fade-enter-active,
.btn__fade-leave-active {
  opacity: 1;
  transition: opacity  var(--a-dur-short) var(--a-func-short);
}
.btn__fade-enter,
.btn__fade-leave-to {
  opacity: 0;
}

.ss__customer__service__list {
  list-style: none;
  li {
    margin: 4px 0;
  }
}

.ss__customer__service__item__link {
  display: flex;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
  font-size: var(--size-SsCustomerServiceItemLinkText, 15px);
  color: var(--color-SsCustomerServiceItemLinkText, var(--B8-t));
  width: var(--width-SsCustomerServiceItemLink, 100%);
  height: var(--height-SsCustomerServiceItemLink, 40px);
  border-radius: var(--radius-SsCustomerServiceItemLink, 12px);
  padding: var(--padding-SsCustomerServiceItemLink, (8px 12px));
  transition: background var(--a-dur-short) var(--a-func-short);
  &:hover {
    background: var(--color-SsCustomerServiceItemLinkText-bg, #0000000D);
    color: var(--color-SsCustomerServiceItemLinkText--hover, var(--B8-t));
  }
  i {
    font-size: var(--size-SsCustomerServiceItemLinkIcon, 24px);
  }
}

.comp__SsFeaturePopover {
  --padding-SsFeaturePopover: 0 4px;
  --width-SsFeaturePopover: 200px;
  >>> .ss__feature__popover {
    margin-top: 4px;
    right: var(--offset-right-SsFeaturePopover);
    left: auto!important;
  }
  >>> .popover__title,
  >>> .popover__content,
  >>> .popover__triangle {
    display: none!important;
  }
  >>> .ss__customer__service__popover-enter-active,
  >>> .ss__customer__service__popover-leave-active {
    opacity: 1;
    transform: translateY(0);
    transition: all var(--a-func-short) var(--a-dur-short);
  }
  >>> .ss__customer__service__popover-enter,
  >>> .ss__customer__service__popover-leave-to {
    opacity: 0;
    transform: translateY(16px);
    transition: all var(--a-func-short) var(--a-dur-short);
  }
}

.comp__SsFeaturePopover__help {
  --width-SsFeaturePopover: 400px;
  --padding-SsFeaturePopover: 48px 40px;
  --color-SsFeaturePopover-bg: #fff;
}

.ss__customer__service__qrcode__wrapper {
  text-align: center;
  .ss__customer__service__qrcode__label {
    color: #000000;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 24px;
  }
}

.ss__customer__service__button--onlyHelp {
  width: var(--width-SsCustomerServiceBtn--onlyHelp, 120px);
  i {
    position: static;
    margin-right: 4px;
  }
}
</style>
